import { b as K } from "./index-jyncyKHm.js";
import "ddc";
const X = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0;
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function Gt(t) {
  return t instanceof Uint8Array || ArrayBuffer.isView(t) && t.constructor.name === "Uint8Array";
}
function ee(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error("positive integer expected, got " + t);
}
function V(t, ...e) {
  if (!Gt(t))
    throw new Error("Uint8Array expected");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error("Uint8Array expected of length " + e + ", got length=" + t.length);
}
function At(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
function ne(t, e) {
  V(t);
  const n = e.outputLen;
  if (t.length < n)
    throw new Error("digestInto() expects output buffer of length at least " + n);
}
function wt(...t) {
  for (let e = 0; e < t.length; e++)
    t[e].fill(0);
}
function ct(t) {
  return new DataView(t.buffer, t.byteOffset, t.byteLength);
}
const Mt = /* @ts-ignore */ typeof Uint8Array.from([]).toHex == "function" && typeof Uint8Array.fromHex == "function", oe = /* @__PURE__ */ Array.from({ length: 256 }, (t, e) => e.toString(16).padStart(2, "0"));
function yt(t) {
  if (V(t), Mt)
    return t.toHex();
  let e = "";
  for (let n = 0; n < t.length; n++)
    e += oe[t[n]];
  return e;
}
const R = { _0: 48, _9: 57, A: 65, F: 70, a: 97, f: 102 };
function St(t) {
  if (t >= R._0 && t <= R._9)
    return t - R._0;
  if (t >= R.A && t <= R.F)
    return t - (R.A - 10);
  if (t >= R.a && t <= R.f)
    return t - (R.a - 10);
}
function Rt(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  if (Mt)
    return Uint8Array.fromHex(t);
  const e = t.length, n = e / 2;
  if (e % 2)
    throw new Error("hex string expected, got unpadded hex of length " + e);
  const o = new Uint8Array(n);
  for (let s = 0, r = 0; s < n; s++, r += 2) {
    const c = St(t.charCodeAt(r)), i = St(t.charCodeAt(r + 1));
    if (c === void 0 || i === void 0) {
      const a = t[r] + t[r + 1];
      throw new Error('hex string expected, got non-hex character "' + a + '" at index ' + r);
    }
    o[s] = c * 16 + i;
  }
  return o;
}
function re(t) {
  if (typeof t != "string")
    throw new Error("string expected");
  return new Uint8Array(new TextEncoder().encode(t));
}
function Ct(t) {
  return typeof t == "string" && (t = re(t)), V(t), t;
}
function vt(...t) {
  let e = 0;
  for (let o = 0; o < t.length; o++) {
    const s = t[o];
    V(s), e += s.length;
  }
  const n = new Uint8Array(e);
  for (let o = 0, s = 0; o < t.length; o++) {
    const r = t[o];
    n.set(r, s), s += r.length;
  }
  return n;
}
class se {
}
function ie(t) {
  const e = (o) => t().update(Ct(o)).digest(), n = t();
  return e.outputLen = n.outputLen, e.blockLen = n.blockLen, e.create = () => t(), e;
}
function ce(t = 32) {
  if (X && typeof X.getRandomValues == "function")
    return X.getRandomValues(new Uint8Array(t));
  if (X && typeof X.randomBytes == "function")
    return Uint8Array.from(X.randomBytes(t));
  throw new Error("crypto.getRandomValues must be defined");
}
function fe(t, e, n, o) {
  if (typeof t.setBigUint64 == "function")
    return t.setBigUint64(e, n, o);
  const s = BigInt(32), r = BigInt(4294967295), c = Number(n >> s & r), i = Number(n & r), a = o ? 4 : 0, d = o ? 0 : 4;
  t.setUint32(e + a, c, o), t.setUint32(e + d, i, o);
}
class ae extends se {
  constructor(e, n, o, s) {
    super(), this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.blockLen = e, this.outputLen = n, this.padOffset = o, this.isLE = s, this.buffer = new Uint8Array(e), this.view = ct(this.buffer);
  }
  update(e) {
    At(this), e = Ct(e), V(e);
    const { view: n, buffer: o, blockLen: s } = this, r = e.length;
    for (let c = 0; c < r; ) {
      const i = Math.min(s - this.pos, r - c);
      if (i === s) {
        const a = ct(e);
        for (; s <= r - c; c += s)
          this.process(a, c);
        continue;
      }
      o.set(e.subarray(c, c + i), this.pos), this.pos += i, c += i, this.pos === s && (this.process(n, 0), this.pos = 0);
    }
    return this.length += e.length, this.roundClean(), this;
  }
  digestInto(e) {
    At(this), ne(e, this), this.finished = !0;
    const { buffer: n, view: o, blockLen: s, isLE: r } = this;
    let { pos: c } = this;
    n[c++] = 128, wt(this.buffer.subarray(c)), this.padOffset > s - c && (this.process(o, 0), c = 0);
    for (let l = c; l < s; l++)
      n[l] = 0;
    fe(o, s - 8, BigInt(this.length * 8), r), this.process(o, 0);
    const i = ct(e), a = this.outputLen;
    if (a % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const d = a / 4, f = this.get();
    if (d > f.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let l = 0; l < d; l++)
      i.setUint32(4 * l, f[l], r);
  }
  digest() {
    const { buffer: e, outputLen: n } = this;
    this.digestInto(e);
    const o = e.slice(0, n);
    return this.destroy(), o;
  }
  _cloneInto(e) {
    e || (e = new this.constructor()), e.set(...this.get());
    const { blockLen: n, buffer: o, length: s, finished: r, destroyed: c, pos: i } = this;
    return e.destroyed = c, e.finished = r, e.length = s, e.pos = i, s % n && e.buffer.set(o), e;
  }
  clone() {
    return this._cloneInto();
  }
}
const U = /* @__PURE__ */ Uint32Array.from([
  1779033703,
  4089235720,
  3144134277,
  2227873595,
  1013904242,
  4271175723,
  2773480762,
  1595750129,
  1359893119,
  2917565137,
  2600822924,
  725511199,
  528734635,
  4215389547,
  1541459225,
  327033209
]), J = /* @__PURE__ */ BigInt(2 ** 32 - 1), _t = /* @__PURE__ */ BigInt(32);
function ue(t, e = !1) {
  return e ? { h: Number(t & J), l: Number(t >> _t & J) } : { h: Number(t >> _t & J) | 0, l: Number(t & J) | 0 };
}
function le(t, e = !1) {
  const n = t.length;
  let o = new Uint32Array(n), s = new Uint32Array(n);
  for (let r = 0; r < n; r++) {
    const { h: c, l: i } = ue(t[r], e);
    [o[r], s[r]] = [c, i];
  }
  return [o, s];
}
const It = (t, e, n) => t >>> n, Nt = (t, e, n) => t << 32 - n | e >>> n, W = (t, e, n) => t >>> n | e << 32 - n, F = (t, e, n) => t << 32 - n | e >>> n, P = (t, e, n) => t << 64 - n | e >>> n - 32, tt = (t, e, n) => t >>> n - 32 | e << 64 - n;
function C(t, e, n, o) {
  const s = (e >>> 0) + (o >>> 0);
  return { h: t + n + (s / 2 ** 32 | 0) | 0, l: s | 0 };
}
const de = (t, e, n) => (t >>> 0) + (e >>> 0) + (n >>> 0), he = (t, e, n, o) => e + n + o + (t / 2 ** 32 | 0) | 0, we = (t, e, n, o) => (t >>> 0) + (e >>> 0) + (n >>> 0) + (o >>> 0), be = (t, e, n, o, s) => e + n + o + s + (t / 2 ** 32 | 0) | 0, xe = (t, e, n, o, s) => (t >>> 0) + (e >>> 0) + (n >>> 0) + (o >>> 0) + (s >>> 0), ge = (t, e, n, o, s, r) => e + n + o + s + r + (t / 2 ** 32 | 0) | 0, Yt = le([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((t) => BigInt(t))), ye = Yt[0], pe = Yt[1], j = /* @__PURE__ */ new Uint32Array(80), k = /* @__PURE__ */ new Uint32Array(80);
class me extends ae {
  constructor(e = 64) {
    super(128, e, 16, !1), this.Ah = U[0] | 0, this.Al = U[1] | 0, this.Bh = U[2] | 0, this.Bl = U[3] | 0, this.Ch = U[4] | 0, this.Cl = U[5] | 0, this.Dh = U[6] | 0, this.Dl = U[7] | 0, this.Eh = U[8] | 0, this.El = U[9] | 0, this.Fh = U[10] | 0, this.Fl = U[11] | 0, this.Gh = U[12] | 0, this.Gl = U[13] | 0, this.Hh = U[14] | 0, this.Hl = U[15] | 0;
  }
  // prettier-ignore
  get() {
    const { Ah: e, Al: n, Bh: o, Bl: s, Ch: r, Cl: c, Dh: i, Dl: a, Eh: d, El: f, Fh: l, Fl: x, Gh: h, Gl: E, Hh: y, Hl: u } = this;
    return [e, n, o, s, r, c, i, a, d, f, l, x, h, E, y, u];
  }
  // prettier-ignore
  set(e, n, o, s, r, c, i, a, d, f, l, x, h, E, y, u) {
    this.Ah = e | 0, this.Al = n | 0, this.Bh = o | 0, this.Bl = s | 0, this.Ch = r | 0, this.Cl = c | 0, this.Dh = i | 0, this.Dl = a | 0, this.Eh = d | 0, this.El = f | 0, this.Fh = l | 0, this.Fl = x | 0, this.Gh = h | 0, this.Gl = E | 0, this.Hh = y | 0, this.Hl = u | 0;
  }
  process(e, n) {
    for (let g = 0; g < 16; g++, n += 4)
      j[g] = e.getUint32(n), k[g] = e.getUint32(n += 4);
    for (let g = 16; g < 80; g++) {
      const v = j[g - 15] | 0, w = k[g - 15] | 0, m = W(v, w, 1) ^ W(v, w, 8) ^ It(v, w, 7), B = F(v, w, 1) ^ F(v, w, 8) ^ Nt(v, w, 7), A = j[g - 2] | 0, S = k[g - 2] | 0, _ = W(A, S, 19) ^ P(A, S, 61) ^ It(A, S, 6), N = F(A, S, 19) ^ tt(A, S, 61) ^ Nt(A, S, 6), H = we(B, N, k[g - 7], k[g - 16]), I = be(H, m, _, j[g - 7], j[g - 16]);
      j[g] = I | 0, k[g] = H | 0;
    }
    let { Ah: o, Al: s, Bh: r, Bl: c, Ch: i, Cl: a, Dh: d, Dl: f, Eh: l, El: x, Fh: h, Fl: E, Gh: y, Gl: u, Hh: b, Hl: p } = this;
    for (let g = 0; g < 80; g++) {
      const v = W(l, x, 14) ^ W(l, x, 18) ^ P(l, x, 41), w = F(l, x, 14) ^ F(l, x, 18) ^ tt(l, x, 41), m = l & h ^ ~l & y, B = x & E ^ ~x & u, A = xe(p, w, B, pe[g], k[g]), S = ge(A, b, v, m, ye[g], j[g]), _ = A | 0, N = W(o, s, 28) ^ P(o, s, 34) ^ P(o, s, 39), H = F(o, s, 28) ^ tt(o, s, 34) ^ tt(o, s, 39), I = o & r ^ o & i ^ r & i, T = s & c ^ s & a ^ c & a;
      b = y | 0, p = u | 0, y = h | 0, u = E | 0, h = l | 0, E = x | 0, { h: l, l: x } = C(d | 0, f | 0, S | 0, _ | 0), d = i | 0, f = a | 0, i = r | 0, a = c | 0, r = o | 0, c = s | 0;
      const Z = de(_, H, T);
      o = he(Z, S, N, I), s = Z | 0;
    }
    ({ h: o, l: s } = C(this.Ah | 0, this.Al | 0, o | 0, s | 0)), { h: r, l: c } = C(this.Bh | 0, this.Bl | 0, r | 0, c | 0), { h: i, l: a } = C(this.Ch | 0, this.Cl | 0, i | 0, a | 0), { h: d, l: f } = C(this.Dh | 0, this.Dl | 0, d | 0, f | 0), { h: l, l: x } = C(this.Eh | 0, this.El | 0, l | 0, x | 0), { h, l: E } = C(this.Fh | 0, this.Fl | 0, h | 0, E | 0), { h: y, l: u } = C(this.Gh | 0, this.Gl | 0, y | 0, u | 0), { h: b, l: p } = C(this.Hh | 0, this.Hl | 0, b | 0, p | 0), this.set(o, s, r, c, i, a, d, f, l, x, h, E, y, u, b, p);
  }
  roundClean() {
    wt(j, k);
  }
  destroy() {
    wt(this.buffer), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const Be = /* @__PURE__ */ ie(() => new me());
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const pt = /* @__PURE__ */ BigInt(0), bt = /* @__PURE__ */ BigInt(1);
function xt(t, e) {
  if (typeof e != "boolean")
    throw new Error(t + " boolean expected, got " + e);
}
function Dt(t) {
  if (typeof t != "string")
    throw new Error("hex string expected, got " + typeof t);
  return t === "" ? pt : BigInt("0x" + t);
}
function Ee(t) {
  return Dt(yt(t));
}
function et(t) {
  return V(t), Dt(yt(Uint8Array.from(t).reverse()));
}
function jt(t, e) {
  return Rt(t.toString(16).padStart(e * 2, "0"));
}
function mt(t, e) {
  return jt(t, e).reverse();
}
function Y(t, e, n) {
  let o;
  if (typeof e == "string")
    try {
      o = Rt(e);
    } catch (r) {
      throw new Error(t + " must be hex string or Uint8Array, cause: " + r);
    }
  else if (Gt(e))
    o = Uint8Array.from(e);
  else
    throw new Error(t + " must be hex string or Uint8Array");
  const s = o.length;
  if (typeof n == "number" && s !== n)
    throw new Error(t + " of length " + n + " expected, got " + s);
  return o;
}
const ft = (t) => typeof t == "bigint" && pt <= t;
function Ae(t, e, n) {
  return ft(t) && ft(e) && ft(n) && e <= t && t < n;
}
function Q(t, e, n, o) {
  if (!Ae(e, n, o))
    throw new Error("expected valid " + t + ": " + n + " <= n < " + o + ", got " + e);
}
function Se(t) {
  let e;
  for (e = 0; t > pt; t >>= bt, e += 1)
    ;
  return e;
}
const Bt = (t) => (bt << BigInt(t)) - bt;
function Et(t, e, n = {}) {
  if (!t || typeof t != "object")
    throw new Error("expected valid options object");
  function o(s, r, c) {
    const i = t[s];
    if (c && i === void 0)
      return;
    const a = typeof i;
    if (a !== r || i === null)
      throw new Error(`param "${s}" is invalid: expected ${r}, got ${a}`);
  }
  Object.entries(e).forEach(([s, r]) => o(s, r, !1)), Object.entries(n).forEach(([s, r]) => o(s, r, !0));
}
function Ht(t) {
  const e = /* @__PURE__ */ new WeakMap();
  return (n, ...o) => {
    const s = e.get(n);
    if (s !== void 0)
      return s;
    const r = t(n, ...o);
    return e.set(n, r), r;
  };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const O = BigInt(0), L = BigInt(1), $ = /* @__PURE__ */ BigInt(2), ve = /* @__PURE__ */ BigInt(3), kt = /* @__PURE__ */ BigInt(4), $t = /* @__PURE__ */ BigInt(5), Vt = /* @__PURE__ */ BigInt(8);
function q(t, e) {
  const n = t % e;
  return n >= O ? n : e + n;
}
function G(t, e, n) {
  let o = t;
  for (; e-- > O; )
    o *= o, o %= n;
  return o;
}
function qt(t, e) {
  if (t === O)
    throw new Error("invert: expected non-zero number");
  if (e <= O)
    throw new Error("invert: expected positive modulus, got " + e);
  let n = q(t, e), o = e, s = O, r = L;
  for (; n !== O; ) {
    const i = o / n, a = o % n, d = s - r * i;
    o = n, n = a, s = r, r = d;
  }
  if (o !== L)
    throw new Error("invert: does not exist");
  return q(s, e);
}
function Xt(t, e) {
  const n = (t.ORDER + L) / kt, o = t.pow(e, n);
  if (!t.eql(t.sqr(o), e))
    throw new Error("Cannot find square root");
  return o;
}
function _e(t, e) {
  const n = (t.ORDER - $t) / Vt, o = t.mul(e, $), s = t.pow(o, n), r = t.mul(e, s), c = t.mul(t.mul(r, $), s), i = t.mul(r, t.sub(c, t.ONE));
  if (!t.eql(t.sqr(i), e))
    throw new Error("Cannot find square root");
  return i;
}
function Ie(t) {
  if (t < BigInt(3))
    throw new Error("sqrt is not defined for small field");
  let e = t - L, n = 0;
  for (; e % $ === O; )
    e /= $, n++;
  let o = $;
  const s = ot(t);
  for (; Tt(s, o) === 1; )
    if (o++ > 1e3)
      throw new Error("Cannot find square root: probably non-prime P");
  if (n === 1)
    return Xt;
  let r = s.pow(o, e);
  const c = (e + L) / $;
  return function(a, d) {
    if (a.is0(d))
      return d;
    if (Tt(a, d) !== 1)
      throw new Error("Cannot find square root");
    let f = n, l = a.mul(a.ONE, r), x = a.pow(d, e), h = a.pow(d, c);
    for (; !a.eql(x, a.ONE); ) {
      if (a.is0(x))
        return a.ZERO;
      let E = 1, y = a.sqr(x);
      for (; !a.eql(y, a.ONE); )
        if (E++, y = a.sqr(y), E === f)
          throw new Error("Cannot find square root");
      const u = L << BigInt(f - E - 1), b = a.pow(l, u);
      f = E, l = a.sqr(b), x = a.mul(x, l), h = a.mul(h, b);
    }
    return h;
  };
}
function Ne(t) {
  return t % kt === ve ? Xt : t % Vt === $t ? _e : Ie(t);
}
const He = (t, e) => (q(t, e) & L) === L, qe = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Te(t) {
  const e = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "number",
    BITS: "number"
  }, n = qe.reduce((o, s) => (o[s] = "function", o), e);
  return Et(t, n), t;
}
function Ze(t, e, n) {
  if (n < O)
    throw new Error("invalid exponent, negatives unsupported");
  if (n === O)
    return t.ONE;
  if (n === L)
    return e;
  let o = t.ONE, s = e;
  for (; n > O; )
    n & L && (o = t.mul(o, s)), s = t.sqr(s), n >>= L;
  return o;
}
function Wt(t, e, n = !1) {
  const o = new Array(e.length).fill(n ? t.ZERO : void 0), s = e.reduce((c, i, a) => t.is0(i) ? c : (o[a] = c, t.mul(c, i)), t.ONE), r = t.inv(s);
  return e.reduceRight((c, i, a) => t.is0(i) ? c : (o[a] = t.mul(c, o[a]), t.mul(c, i)), r), o;
}
function Tt(t, e) {
  const n = (t.ORDER - L) / $, o = t.pow(e, n), s = t.eql(o, t.ONE), r = t.eql(o, t.ZERO), c = t.eql(o, t.neg(t.ONE));
  if (!s && !r && !c)
    throw new Error("invalid Legendre symbol result");
  return s ? 1 : r ? 0 : -1;
}
function Ue(t, e) {
  e !== void 0 && ee(e);
  const n = e !== void 0 ? e : t.toString(2).length, o = Math.ceil(n / 8);
  return { nBitLength: n, nByteLength: o };
}
function ot(t, e, n = !1, o = {}) {
  if (t <= O)
    throw new Error("invalid field: expected ORDER > 0, got " + t);
  let s, r;
  if (typeof e == "object" && e != null) {
    if (o.sqrt || n)
      throw new Error("cannot specify opts in two arguments");
    const f = e;
    f.BITS && (s = f.BITS), f.sqrt && (r = f.sqrt), typeof f.isLE == "boolean" && (n = f.isLE);
  } else
    typeof e == "number" && (s = e), o.sqrt && (r = o.sqrt);
  const { nBitLength: c, nByteLength: i } = Ue(t, s);
  if (i > 2048)
    throw new Error("invalid field: expected ORDER of <= 2048 bytes");
  let a;
  const d = Object.freeze({
    ORDER: t,
    isLE: n,
    BITS: c,
    BYTES: i,
    MASK: Bt(c),
    ZERO: O,
    ONE: L,
    create: (f) => q(f, t),
    isValid: (f) => {
      if (typeof f != "bigint")
        throw new Error("invalid field element: expected bigint, got " + typeof f);
      return O <= f && f < t;
    },
    is0: (f) => f === O,
    // is valid and invertible
    isValidNot0: (f) => !d.is0(f) && d.isValid(f),
    isOdd: (f) => (f & L) === L,
    neg: (f) => q(-f, t),
    eql: (f, l) => f === l,
    sqr: (f) => q(f * f, t),
    add: (f, l) => q(f + l, t),
    sub: (f, l) => q(f - l, t),
    mul: (f, l) => q(f * l, t),
    pow: (f, l) => Ze(d, f, l),
    div: (f, l) => q(f * qt(l, t), t),
    // Same as above, but doesn't normalize
    sqrN: (f) => f * f,
    addN: (f, l) => f + l,
    subN: (f, l) => f - l,
    mulN: (f, l) => f * l,
    inv: (f) => qt(f, t),
    sqrt: r || ((f) => (a || (a = Ne(t)), a(d, f))),
    toBytes: (f) => n ? mt(f, i) : jt(f, i),
    fromBytes: (f) => {
      if (f.length !== i)
        throw new Error("Field.fromBytes: expected " + i + " bytes, got " + f.length);
      return n ? et(f) : Ee(f);
    },
    // TODO: we don't need it here, move out to separate fn
    invertBatch: (f) => Wt(d, f),
    // We can't move this out because Fp6, Fp12 implement it
    // and it's unclear what to return in there.
    cmov: (f, l, x) => x ? l : f
  });
  return Object.freeze(d);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const nt = BigInt(0), gt = BigInt(1);
function at(t, e) {
  const n = e.negate();
  return t ? n : e;
}
function ze(t, e, n) {
  const o = (c) => c.ez, s = Wt(t.Fp, n.map(o));
  return n.map((c, i) => c.toAffine(s[i])).map(t.fromAffine);
}
function Ft(t, e) {
  if (!Number.isSafeInteger(t) || t <= 0 || t > e)
    throw new Error("invalid window size, expected [1.." + e + "], got W=" + t);
}
function ut(t, e) {
  Ft(t, e);
  const n = Math.ceil(e / t) + 1, o = 2 ** (t - 1), s = 2 ** t, r = Bt(t), c = BigInt(t);
  return { windows: n, windowSize: o, mask: r, maxNumber: s, shiftBy: c };
}
function Zt(t, e, n) {
  const { windowSize: o, mask: s, maxNumber: r, shiftBy: c } = n;
  let i = Number(t & s), a = t >> c;
  i > o && (i -= r, a += gt);
  const d = e * o, f = d + Math.abs(i) - 1, l = i === 0, x = i < 0, h = e % 2 !== 0;
  return { nextN: a, offset: f, isZero: l, isNeg: x, isNegF: h, offsetF: d };
}
function Le(t, e) {
  if (!Array.isArray(t))
    throw new Error("array expected");
  t.forEach((n, o) => {
    if (!(n instanceof e))
      throw new Error("invalid point at index " + o);
  });
}
function Oe(t, e) {
  if (!Array.isArray(t))
    throw new Error("array of scalars expected");
  t.forEach((n, o) => {
    if (!e.isValid(n))
      throw new Error("invalid scalar at index " + o);
  });
}
const lt = /* @__PURE__ */ new WeakMap(), Kt = /* @__PURE__ */ new WeakMap();
function dt(t) {
  return Kt.get(t) || 1;
}
function Ut(t) {
  if (t !== nt)
    throw new Error("invalid wNAF");
}
function Ge(t, e) {
  return {
    constTimeNegate: at,
    hasPrecomputes(n) {
      return dt(n) !== 1;
    },
    // non-const time multiplication ladder
    unsafeLadder(n, o, s = t.ZERO) {
      let r = n;
      for (; o > nt; )
        o & gt && (s = s.add(r)), r = r.double(), o >>= gt;
      return s;
    },
    /**
     * Creates a wNAF precomputation window. Used for caching.
     * Default window size is set by `utils.precompute()` and is equal to 8.
     * Number of precomputed points depends on the curve size:
     * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
     * - 𝑊 is the window size
     * - 𝑛 is the bitlength of the curve order.
     * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
     * @param elm Point instance
     * @param W window size
     * @returns precomputed point tables flattened to a single array
     */
    precomputeWindow(n, o) {
      const { windows: s, windowSize: r } = ut(o, e), c = [];
      let i = n, a = i;
      for (let d = 0; d < s; d++) {
        a = i, c.push(a);
        for (let f = 1; f < r; f++)
          a = a.add(i), c.push(a);
        i = a.double();
      }
      return c;
    },
    /**
     * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @returns real and fake (for const-time) points
     */
    wNAF(n, o, s) {
      let r = t.ZERO, c = t.BASE;
      const i = ut(n, e);
      for (let a = 0; a < i.windows; a++) {
        const { nextN: d, offset: f, isZero: l, isNeg: x, isNegF: h, offsetF: E } = Zt(s, a, i);
        s = d, l ? c = c.add(at(h, o[E])) : r = r.add(at(x, o[f]));
      }
      return Ut(s), { p: r, f: c };
    },
    /**
     * Implements ec unsafe (non const-time) multiplication using precomputed tables and w-ary non-adjacent form.
     * @param W window size
     * @param precomputes precomputed tables
     * @param n scalar (we don't check here, but should be less than curve order)
     * @param acc accumulator point to add result of multiplication
     * @returns point
     */
    wNAFUnsafe(n, o, s, r = t.ZERO) {
      const c = ut(n, e);
      for (let i = 0; i < c.windows && s !== nt; i++) {
        const { nextN: a, offset: d, isZero: f, isNeg: l } = Zt(s, i, c);
        if (s = a, !f) {
          const x = o[d];
          r = r.add(l ? x.negate() : x);
        }
      }
      return Ut(s), r;
    },
    getPrecomputes(n, o, s) {
      let r = lt.get(o);
      return r || (r = this.precomputeWindow(o, n), n !== 1 && (typeof s == "function" && (r = s(r)), lt.set(o, r))), r;
    },
    wNAFCached(n, o, s) {
      const r = dt(n);
      return this.wNAF(r, this.getPrecomputes(r, n, s), o);
    },
    wNAFCachedUnsafe(n, o, s, r) {
      const c = dt(n);
      return c === 1 ? this.unsafeLadder(n, o, r) : this.wNAFUnsafe(c, this.getPrecomputes(c, n, s), o, r);
    },
    // We calculate precomputes for elliptic curve point multiplication
    // using windowed method. This specifies window size and
    // stores precomputed values. Usually only base point would be precomputed.
    setWindowSize(n, o) {
      Ft(o, e), Kt.set(n, o), lt.delete(n);
    }
  };
}
function Me(t, e, n, o) {
  Le(n, t), Oe(o, e);
  const s = n.length, r = o.length;
  if (s !== r)
    throw new Error("arrays of points and scalars must have equal length");
  const c = t.ZERO, i = Se(BigInt(s));
  let a = 1;
  i > 12 ? a = i - 3 : i > 4 ? a = i - 2 : i > 0 && (a = 2);
  const d = Bt(a), f = new Array(Number(d) + 1).fill(c), l = Math.floor((e.BITS - 1) / a) * a;
  let x = c;
  for (let h = l; h >= 0; h -= a) {
    f.fill(c);
    for (let y = 0; y < r; y++) {
      const u = o[y], b = Number(u >> BigInt(h) & d);
      f[b] = f[b].add(n[y]);
    }
    let E = c;
    for (let y = f.length - 1, u = c; y > 0; y--)
      u = u.add(f[y]), E = E.add(u);
    if (x = x.add(E), h !== 0)
      for (let y = 0; y < a; y++)
        x = x.double();
  }
  return x;
}
function zt(t, e) {
  if (e) {
    if (e.ORDER !== t)
      throw new Error("Field.ORDER must match order: Fp == p, Fn == n");
    return Te(e), e;
  } else
    return ot(t);
}
function Re(t, e, n = {}) {
  if (!e || typeof e != "object")
    throw new Error(`expected valid ${t} CURVE object`);
  for (const i of ["p", "n", "h"]) {
    const a = e[i];
    if (!(typeof a == "bigint" && a > nt))
      throw new Error(`CURVE.${i} must be positive bigint`);
  }
  const o = zt(e.p, n.Fp), s = zt(e.n, n.Fn), c = ["Gx", "Gy", "a", "d"];
  for (const i of c)
    if (!o.isValid(e[i]))
      throw new Error(`CURVE.${i} must be valid field element of CURVE.Fp`);
  return { Fp: o, Fn: s };
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const M = BigInt(0), z = BigInt(1), ht = BigInt(2), Ce = BigInt(8), Ye = { zip215: !0 };
function De(t, e, n, o) {
  const s = t.sqr(n), r = t.sqr(o), c = t.add(t.mul(e.a, s), r), i = t.add(t.ONE, t.mul(e.d, t.mul(s, r)));
  return t.eql(c, i);
}
function je(t, e = {}) {
  const { Fp: n, Fn: o } = Re("edwards", t, e), { h: s, n: r } = t;
  Et(e, {}, { uvRatio: "function" });
  const c = ht << BigInt(o.BYTES * 8) - z, i = (y) => n.create(y), a = e.uvRatio || ((y, u) => {
    try {
      return { isValid: !0, value: n.sqrt(n.div(y, u)) };
    } catch {
      return { isValid: !1, value: M };
    }
  });
  if (!De(n, t, t.Gx, t.Gy))
    throw new Error("bad curve params: generator point");
  function d(y, u, b = !1) {
    const p = b ? z : M;
    return Q("coordinate " + y, u, p, c), u;
  }
  function f(y) {
    if (!(y instanceof h))
      throw new Error("ExtendedPoint expected");
  }
  const l = Ht((y, u) => {
    const { ex: b, ey: p, ez: g } = y, v = y.is0();
    u == null && (u = v ? Ce : n.inv(g));
    const w = i(b * u), m = i(p * u), B = i(g * u);
    if (v)
      return { x: M, y: z };
    if (B !== z)
      throw new Error("invZ was invalid");
    return { x: w, y: m };
  }), x = Ht((y) => {
    const { a: u, d: b } = t;
    if (y.is0())
      throw new Error("bad point: ZERO");
    const { ex: p, ey: g, ez: v, et: w } = y, m = i(p * p), B = i(g * g), A = i(v * v), S = i(A * A), _ = i(m * u), N = i(A * i(_ + B)), H = i(S + i(b * i(m * B)));
    if (N !== H)
      throw new Error("bad point: equation left != right (1)");
    const I = i(p * g), T = i(v * w);
    if (I !== T)
      throw new Error("bad point: equation left != right (2)");
    return !0;
  });
  class h {
    constructor(u, b, p, g) {
      this.ex = d("x", u), this.ey = d("y", b), this.ez = d("z", p, !0), this.et = d("t", g), Object.freeze(this);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static fromAffine(u) {
      if (u instanceof h)
        throw new Error("extended point not allowed");
      const { x: b, y: p } = u || {};
      return d("x", b), d("y", p), new h(b, p, z, i(b * p));
    }
    static normalizeZ(u) {
      return ze(h, "ez", u);
    }
    // Multiscalar Multiplication
    static msm(u, b) {
      return Me(h, o, u, b);
    }
    // "Private method", don't use it directly
    _setWindowSize(u) {
      this.precompute(u);
    }
    precompute(u = 8, b = !0) {
      return E.setWindowSize(this, u), b || this.multiply(ht), this;
    }
    // Not required for fromHex(), which always creates valid points.
    // Could be useful for fromAffine().
    assertValidity() {
      x(this);
    }
    // Compare one point to another.
    equals(u) {
      f(u);
      const { ex: b, ey: p, ez: g } = this, { ex: v, ey: w, ez: m } = u, B = i(b * m), A = i(v * g), S = i(p * m), _ = i(w * g);
      return B === A && S === _;
    }
    is0() {
      return this.equals(h.ZERO);
    }
    negate() {
      return new h(i(-this.ex), this.ey, this.ez, i(-this.et));
    }
    // Fast algo for doubling Extended Point.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#doubling-dbl-2008-hwcd
    // Cost: 4M + 4S + 1*a + 6add + 1*2.
    double() {
      const { a: u } = t, { ex: b, ey: p, ez: g } = this, v = i(b * b), w = i(p * p), m = i(ht * i(g * g)), B = i(u * v), A = b + p, S = i(i(A * A) - v - w), _ = B + w, N = _ - m, H = B - w, I = i(S * N), T = i(_ * H), Z = i(S * H), D = i(N * _);
      return new h(I, T, D, Z);
    }
    // Fast algo for adding 2 Extended Points.
    // https://hyperelliptic.org/EFD/g1p/auto-twisted-extended.html#addition-add-2008-hwcd
    // Cost: 9M + 1*a + 1*d + 7add.
    add(u) {
      f(u);
      const { a: b, d: p } = t, { ex: g, ey: v, ez: w, et: m } = this, { ex: B, ey: A, ez: S, et: _ } = u, N = i(g * B), H = i(v * A), I = i(m * p * _), T = i(w * S), Z = i((g + v) * (B + A) - N - H), D = T - I, st = T + I, it = i(H - b * N), Qt = i(Z * D), Jt = i(st * it), Pt = i(Z * it), te = i(D * st);
      return new h(Qt, Jt, te, Pt);
    }
    subtract(u) {
      return this.add(u.negate());
    }
    // Constant-time multiplication.
    multiply(u) {
      const b = u;
      Q("scalar", b, z, r);
      const { p, f: g } = E.wNAFCached(this, b, h.normalizeZ);
      return h.normalizeZ([p, g])[0];
    }
    // Non-constant-time multiplication. Uses double-and-add algorithm.
    // It's faster, but should only be used when you don't care about
    // an exposed private key e.g. sig verification.
    // Does NOT allow scalars higher than CURVE.n.
    // Accepts optional accumulator to merge with multiply (important for sparse scalars)
    multiplyUnsafe(u, b = h.ZERO) {
      const p = u;
      return Q("scalar", p, M, r), p === M ? h.ZERO : this.is0() || p === z ? this : E.wNAFCachedUnsafe(this, p, h.normalizeZ, b);
    }
    // Checks if point is of small order.
    // If you add something to small order point, you will have "dirty"
    // point with torsion component.
    // Multiplies point by cofactor and checks if the result is 0.
    isSmallOrder() {
      return this.multiplyUnsafe(s).is0();
    }
    // Multiplies point by curve order and checks if the result is 0.
    // Returns `false` is the point is dirty.
    isTorsionFree() {
      return E.wNAFCachedUnsafe(this, r).is0();
    }
    // Converts Extended point to default (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    toAffine(u) {
      return l(this, u);
    }
    clearCofactor() {
      return s === z ? this : this.multiplyUnsafe(s);
    }
    static fromBytes(u, b = !1) {
      return V(u), this.fromHex(u, b);
    }
    // Converts hash string or Uint8Array to Point.
    // Uses algo from RFC8032 5.1.3.
    static fromHex(u, b = !1) {
      const { d: p, a: g } = t, v = n.BYTES;
      u = Y("pointHex", u, v), xt("zip215", b);
      const w = u.slice(), m = u[v - 1];
      w[v - 1] = m & -129;
      const B = et(w), A = b ? c : n.ORDER;
      Q("pointHex.y", B, M, A);
      const S = i(B * B), _ = i(S - z), N = i(p * S - g);
      let { isValid: H, value: I } = a(_, N);
      if (!H)
        throw new Error("Point.fromHex: invalid y coordinate");
      const T = (I & z) === z, Z = (m & 128) !== 0;
      if (!b && I === M && Z)
        throw new Error("Point.fromHex: x=0 and x_0=1");
      return Z !== T && (I = i(-I)), h.fromAffine({ x: I, y: B });
    }
    static fromPrivateScalar(u) {
      return h.BASE.multiply(u);
    }
    toBytes() {
      const { x: u, y: b } = this.toAffine(), p = mt(b, n.BYTES);
      return p[p.length - 1] |= u & z ? 128 : 0, p;
    }
    /** @deprecated use `toBytes` */
    toRawBytes() {
      return this.toBytes();
    }
    toHex() {
      return yt(this.toBytes());
    }
    toString() {
      return `<Point ${this.is0() ? "ZERO" : this.toHex()}>`;
    }
  }
  h.BASE = new h(t.Gx, t.Gy, z, i(t.Gx * t.Gy)), h.ZERO = new h(M, z, z, M), h.Fp = n, h.Fn = o;
  const E = Ge(h, o.BYTES * 8);
  return h;
}
function ke(t, e) {
  Et(e, {
    hash: "function"
  }, {
    adjustScalarBytes: "function",
    randomBytes: "function",
    domain: "function",
    prehash: "function",
    mapToCurve: "function"
  });
  const { prehash: n, hash: o } = e, { BASE: s, Fp: r, Fn: c } = t, i = c.ORDER, a = e.randomBytes || ce, d = e.adjustScalarBytes || ((w) => w), f = e.domain || ((w, m, B) => {
    if (xt("phflag", B), m.length || B)
      throw new Error("Contexts/pre-hash are not supported");
    return w;
  });
  function l(w) {
    return c.create(w);
  }
  function x(w) {
    return l(et(w));
  }
  function h(w) {
    const m = r.BYTES;
    w = Y("private key", w, m);
    const B = Y("hashed private key", o(w), 2 * m), A = d(B.slice(0, m)), S = B.slice(m, 2 * m), _ = x(A);
    return { head: A, prefix: S, scalar: _ };
  }
  function E(w) {
    const { head: m, prefix: B, scalar: A } = h(w), S = s.multiply(A), _ = S.toBytes();
    return { head: m, prefix: B, scalar: A, point: S, pointBytes: _ };
  }
  function y(w) {
    return E(w).pointBytes;
  }
  function u(w = Uint8Array.of(), ...m) {
    const B = vt(...m);
    return x(o(f(B, Y("context", w), !!n)));
  }
  function b(w, m, B = {}) {
    w = Y("message", w), n && (w = n(w));
    const { prefix: A, scalar: S, pointBytes: _ } = E(m), N = u(B.context, A, w), H = s.multiply(N).toBytes(), I = u(B.context, H, _, w), T = l(N + I * S);
    Q("signature.s", T, M, i);
    const Z = r.BYTES, D = vt(H, mt(T, Z));
    return Y("result", D, Z * 2);
  }
  const p = Ye;
  function g(w, m, B, A = p) {
    const { context: S, zip215: _ } = A, N = r.BYTES;
    w = Y("signature", w, 2 * N), m = Y("message", m), B = Y("publicKey", B, N), _ !== void 0 && xt("zip215", _), n && (m = n(m));
    const H = et(w.slice(N, 2 * N));
    let I, T, Z;
    try {
      I = t.fromHex(B, _), T = t.fromHex(w.slice(0, N), _), Z = s.multiplyUnsafe(H);
    } catch {
      return !1;
    }
    if (!_ && I.isSmallOrder())
      return !1;
    const D = u(S, T.toBytes(), I.toBytes(), m);
    return T.add(I.multiplyUnsafe(D)).subtract(Z).clearCofactor().is0();
  }
  return s.precompute(8), { getPublicKey: y, sign: b, verify: g, utils: {
    getExtendedPublicKey: E,
    /** ed25519 priv keys are uniform 32b. No need to check for modulo bias, like in secp256k1. */
    randomPrivateKey: () => a(r.BYTES),
    /**
     * We're doing scalar multiplication (used in getPublicKey etc) with precomputed BASE_POINT
     * values. This slows down first getPublicKey() by milliseconds (see Speed section),
     * but allows to speed-up subsequent getPublicKey() calls up to 20x.
     * @param windowSize 2, 4, 8, 16
     */
    precompute(w = 8, m = t.BASE) {
      return m.precompute(w, !1);
    }
  }, Point: t };
}
function $e(t) {
  const e = {
    a: t.a,
    d: t.d,
    p: t.Fp.ORDER,
    n: t.n,
    h: t.h,
    Gx: t.Gx,
    Gy: t.Gy
  }, n = t.Fp, o = ot(e.n, t.nBitLength, !0), s = { Fp: n, Fn: o, uvRatio: t.uvRatio }, r = {
    hash: t.hash,
    randomBytes: t.randomBytes,
    adjustScalarBytes: t.adjustScalarBytes,
    domain: t.domain,
    prehash: t.prehash,
    mapToCurve: t.mapToCurve
  };
  return { CURVE: e, curveOpts: s, eddsaOpts: r };
}
function Ve(t, e) {
  return Object.assign({}, e, { ExtendedPoint: e.Point, CURVE: t });
}
function Xe(t) {
  const { CURVE: e, curveOpts: n, eddsaOpts: o } = $e(t), s = je(e, n), r = ke(s, o);
  return Ve(t, r);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
BigInt(0);
const We = BigInt(1), Lt = BigInt(2);
BigInt(3);
const Fe = BigInt(5), Ke = BigInt(8), rt = {
  p: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffed"),
  n: BigInt("0x1000000000000000000000000000000014def9dea2f79cd65812631a5cf5d3ed"),
  h: Ke,
  a: BigInt("0x7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffec"),
  d: BigInt("0x52036cee2b6ffe738cc740797779e89800700a4d4141d8ab75eb4dca135978a3"),
  Gx: BigInt("0x216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a"),
  Gy: BigInt("0x6666666666666666666666666666666666666666666666666666666666666658")
};
function Qe(t) {
  const e = BigInt(10), n = BigInt(20), o = BigInt(40), s = BigInt(80), r = rt.p, i = t * t % r * t % r, a = G(i, Lt, r) * i % r, d = G(a, We, r) * t % r, f = G(d, Fe, r) * d % r, l = G(f, e, r) * f % r, x = G(l, n, r) * l % r, h = G(x, o, r) * x % r, E = G(h, s, r) * h % r, y = G(E, s, r) * h % r, u = G(y, e, r) * f % r;
  return { pow_p_5_8: G(u, Lt, r) * t % r, b2: i };
}
function Je(t) {
  return t[0] &= 248, t[31] &= 127, t[31] |= 64, t;
}
const Ot = /* @__PURE__ */ BigInt("19681161376707505956807079304988542015446066515923890162744021073123829784752");
function Pe(t, e) {
  const n = rt.p, o = q(e * e * e, n), s = q(o * o * e, n), r = Qe(t * s).pow_p_5_8;
  let c = q(t * o * r, n);
  const i = q(e * c * c, n), a = c, d = q(c * Ot, n), f = i === t, l = i === q(-t, n), x = i === q(-t * Ot, n);
  return f && (c = a), (l || x) && (c = d), He(c, n) && (c = q(-c, n)), { isValid: f || l, value: c };
}
const tn = ot(rt.p, void 0, !0), en = {
  ...rt,
  Fp: tn,
  hash: Be,
  adjustScalarBytes: Je,
  // dom2
  // Ratio of u to v. Allows us to combine inversion and square root. Uses algo from RFC8032 5.1.3.
  // Constant-time, u/√v
  uvRatio: Pe
}, nn = Xe(en);
function sn(t, e, n, o) {
  const s = K.Buffer.from(t), r = K.Buffer.alloc(4);
  r.writeUInt32LE(n.version);
  const c = K.Buffer.from(e), i = K.Buffer.from(n.content), a = K.Buffer.concat([
    s,
    r,
    c,
    i
  ]);
  return nn.verify(
    n.signatureHex,
    a,
    o
  );
}
export {
  sn as isSignedContentValid
};
//# sourceMappingURL=integrity_store.js.map
